module.exports = __webpack_public_path__ + "static/img/img09.a5ccc96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img09.png
// module id = fwat
// module chunks = 1